module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Social_Comments_Form', {
		configure: function(options) {
			this.registerOptions('', {
				autoRender: true,
				handleDom: {
					bindSubmitHandler: {
						target: 'textarea',
						event: 'focus',
						callback: '_bindSubmitHandler'
					},
					unbindSubmitHandler: {
						target: 'textarea',
						event: 'blur',
						callback: '_unbindSubmitHandler'
					}
				}
			});
			return this.callParent('configure', arguments);
		},

		init: function() {
			this.embedWidget('form', 'Form', {
				'hooks.onSubmit': fox.bind(this.submit, this),
			});

			return this.callParent('init', arguments);
		},

		submit: function(obj) {
			var date = new Date();

			obj.userId = fox.site.member.getObjectValue('id');
			obj.name = fox.site.member.getObjectValue('login');

			obj.date = fox.utils.dateFormat('%Y-%m-%d %I:%M:%S %p', new Date());
			obj.targetId = this.requireOption('targetId');
			this.getParent().addComment(obj);
		},

		_bindSubmitHandler: function (el) {
			$(el).on('keyup', {widget: this}, this._kbSubmitHandler)
		},

		_unbindSubmitHandler: function (el) {
			$(el).off('keyup', this._kbSubmitHandler)
		},

		_kbSubmitHandler: function (e) {
			if (e.keyCode == 13 && e.ctrlKey) {
				e.data.widget.rwom1('#form')._submit();
			}
		}

	});
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/social/comments/form.js
// module id = 453
// module chunks = 4